import pushClevertapEvent from 'clevertap/pushClevertapEvent';

import formatDate from 'clevertap/formatDate';
import { getToggleAllDayState } from 'clevertap/hourFilter';

export function reportCollectedStart({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Collected Start', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function reportCollectedExport({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Report Collected Export', {
    'Current Selected Outlet': outletIds,
    'Toggle All Day': getToggleAllDayState(endDate),
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}
